import Card from "react-bootstrap/Card";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { addToCart } from "../../../redux/addToCart/addToCartSlice";
import "./ProductCard.scss";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../../init.firebase";
import { useAddToCartNewDataByEmailMutation } from "../../../redux/addToCart/addToCartApi";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { addToCombo } from "../../../redux/combo/comboSlice";

const ProductCard = ({ cart, setShow, isCombo } = {}) => {
  const [user] = useAuthState(auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    _id,
    name,
    price,
    images,
    discountPercentage,
    manufacturer,
    reviews,
    expireDate,
    status,
  } = cart || {};

  const [
    addToCartNewDataByEmail,
    {
      isLoading: addCartLoading,
      isSuccess: addToCartSuccess,
      isError: addToCartError,
    },
  ] = useAddToCartNewDataByEmailMutation();

  const handleAddToBag = (cart) => {
    if (user) {
      const data = {
        product: cart._id,
      };
      const userEmail = user.email;

      addToCartNewDataByEmail({ userEmail, data });
    } else {
      navigate("/account/login");
    }
    setShow(true);
  };
  const handleAddToCombo = (cart) => {
    dispatch(addToCombo(cart));
  };

  {
    addToCartError && toast.error("Failed to add a product to your cart");
  }
  let discountPrice = null;
  if (discountPercentage > 0) {
    discountPrice = price - ((discountPercentage / 100) * price).toFixed(2);
  }
  console.log(cart);
  return (
    <Card className="parent position-relative border-0 h-100 rounded-0 overflow-visible">
      <Link
        to={`/product-detail/${_id}`}
        style={{
          margin: "auto",
          marginTop: "1px",
          color: "black",
          textDecoration: "none",
        }}
      >
        <Card.Img src={images?.[0]} className="card_image" alt={name} fluid />
      </Link>

      <div
        className=" text-dark text-decoration-none px-1 fw-bold mb-1"
        style={{ fontSize: "15px" }}
      >
        {manufacturer?.name || "BRAND"}
      </div>

      <Card.Body>
        <Link
          to={`product-detail/${_id}`}
          style={{ color: "black", textDecoration: "none" }}
        >
          <Card.Title className="px-1 product_name">{name}</Card.Title>
        </Link>
        <Link
          to={`product-detail/${_id}`}
          style={{ color: "black", textDecoration: "none" }}
        >
          <Card.Text
            className="card-texts "
            style={{
              fontSize: "0.8125rem",
              lineHeight: "16px",
              color: "#8d8d8d",
            }}
          ></Card.Text>
        </Link>
        {/* <div className="mt-2 d-flex align-items-center justify-content-center ">
          <MdStar />
          <MdStar />
          <MdStar />
          <MdStarHalf />
          <MdStarOutline />
        </div>
        <span style={{ fontSize: "0.8125rem" }}>
          ({reviews?.length} reviews)
        </span> */}
        <p
          className="mt-2 px-1"
          style={{
            color: "#FF0202",
            fontSize: "0.8125rem",
            fontWeight: "bold",
          }}
        >
          {discountPercentage > 0 && `Save ${discountPercentage} %`}
        </p>
        <div className="text-center text-muted" style={{ fontSize: "12px" }}>
          {expireDate && `EXP: ${new Date(expireDate).toLocaleDateString()}`}
        </div>
      </Card.Body>
      <Card.Footer
        className="border-0 bg-transparent "
        style={{ padding: "0px" }}
      >
        {isCombo ? (
          <button
            disabled={status?.toLowerCase() === "out-of-stock"}
            onClick={() => handleAddToCombo(cart)}
            variant="light"
            className="w-100 bg-light border d-flex align-items-center justify-content-between fw-bold px-2"
            style={{ height: "2.625rem", fontSize: "0.8125rem" }}
          >
            <div
              style={{
                color: "black",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              {status?.toLowerCase() === "out-of-stock"
                ? "Out-of-Stock"
                : "Add to combo"}
            </div>
            {/* <Spinner animation="border" variant="primary" /> */}
            <span>
              {discountPrice ? (
                <span>
                  ৳ {discountPrice}{" "}
                  <strike className="ms-2 text-secondary">৳ {price}</strike>
                </span>
              ) : (
                <span>৳ {price}</span>
              )}
            </span>
          </button>
        ) : (
          <button
            disabled={status?.toLowerCase() === "out-of-stock"}
            onClick={() => handleAddToBag(cart)}
            variant="light"
            className="w-100 bg-light border d-flex align-items-center justify-content-between fw-bold px-2"
            style={{ height: "2.625rem", fontSize: "0.8125rem" }}
          >
            <div
              style={{
                color: "black",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              {addCartLoading
                ? "Adding to bag..."
                : status?.toLowerCase() === "out-of-stock"
                ? "Out-of-Stock"
                : "Add to Bag"}
            </div>
            {/* <Spinner animation="border" variant="primary" /> */}
            <span>
              {discountPrice ? (
                <span>
                  ৳ {discountPrice}{" "}
                  <strike className="ms-2 text-secondary">৳ {price}</strike>
                </span>
              ) : (
                <span>৳ {price}</span>
              )}
            </span>
          </button>
        )}
      </Card.Footer>
    </Card>
  );
};

export default ProductCard;
